import { FC } from 'react'

import { colors } from '../../theme'
import Highlight from '../Highlight'
import { ContentCardProps } from '../ContentCard'
import { ContentCardGroupProps } from '../ContentCardGroup'
import NonCollapsable from '../NonCollapsable'
import ContentCards from '../ContentCards'

import * as SC from './styled'

export type OthersSectionProps = {
  title?: string
  items: (ContentCardProps | ContentCardGroupProps)[]
}

const OthersSection: FC<OthersSectionProps> = ({ title, items }) => {
  return (
    <NonCollapsable>
      <SC.Wrapper>
        <SC.Title>
          <Highlight
            backgroundColor={colors.greenMint}
            color={colors.pureBlack}
            text={title ?? ''}
          />
        </SC.Title>
        <SC.Content>
          {items && items?.length > 0 && <ContentCards items={items} />}
        </SC.Content>
      </SC.Wrapper>
    </NonCollapsable>
  )
}

export default OthersSection
